// One connection per audience/session. Listener lifetimes are independent.
export default class ConnectionPool {
  #createConnection;
  #onListenerError;
  #entries;
  constructor({ createConnection, onListenerError }) {
    this.#createConnection = createConnection;
    this.#onListenerError = onListenerError;
    this.#entries = new Map();
  }

  #notify(listener, event) {
    try { listener(event); } catch { this.#onListenerError(); }
  }

  subscribe(kind, token, listener) {
    const key = `${kind}:${token}`;
    let entry = this.#entries.get(key);
    const first = !entry;
    if (first) {
      entry = { connection: this.#createConnection(kind, token), listeners: new Set(), status: 'connecting' };
      this.#entries.set(key, entry);
    }
    // Same callback may be subscribed twice; each lease must be independent.
    const lease = event => this.#notify(listener, event);
    entry.listeners.add(lease);
    lease({ type: 'connection', status: entry.status });
    if (first) {
      entry.connection.start(event => {
        if (event.type === 'connection') entry.status = event.status;
        for (const subscriber of [...entry.listeners]) subscriber(event);
      });
    } else if (entry.status === 'connected') lease({ type: 'ready' });
    let released = false;
    return () => {
      if (released) return;
      released = true; entry.listeners.delete(lease);
      if (entry.listeners.size) return;
      entry.connection.stop();
      if (this.#entries.get(key) === entry) this.#entries.delete(key);
    };
  }
}
